<script lang="ts" setup>

import { rankingConfig as rocnovelConfig } from './configs/rocnovel'




















import RankingPageDefault from './components/RankingPage.default.vue'






import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

defineProps<{
  columnId: string
}>()

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({ rocnovel: rocnovelConfig })

// 🔥 加载当前品牌组件（rocnovel 和 oceread 共用 default，ficmoon 和 novelarc 用专属组件）
const RankingPage = loadBrandComponent({ rocnovel: RankingPageDefault })
</script>

<template>
  <div>
    <!-- 🔥 品牌专属页面组件 -->
    <RankingPage :column-id="columnId" :config="config" />
  </div>
</template>
